import React, { Component } from "react";
import axios from "axios";
import ParticlesBg from "particles-bg";
import Fade from "react-reveal";

class Header extends Component {

  constructor(props) {
    super(props)
  
    this.state = {
      name : 'Weather API',
      description : "This web-app is used to get the temperature of the City",
      City_name : 'Erode'
    }
  }
  handleclick(){

    const new_city = document.getElementById('City_name').value;
    axios.get(`https://api.openweathermap.org/data/2.5/weather?q=${new_city}&units=metric&appid=e4d1ef7fa385c320c4dd75c1ea666ee5`)
    .then((response) => {
        // console.log(response)
        this.setState({ description : ` Today's Temperature in ${new_city} is ${response.data.main.temp} Celsius`})
    })
    .catch((e) => {
        window.alert(`${new_city} is a invalid City Name`)
        console.warn(e)
    })
}
  render() {    
  return (
      <header id="home">
        <ParticlesBg type="circle" bg={true} />

        <nav id="nav-wrap">
          <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
            Show navigation
          </a>
          <a className="mobile-btn" href="#home" title="Hide navigation">
            Hide navigation
          </a>

          <ul id="nav" className="nav">
            <li className="current">
              <a className="smoothscroll" href="#home">
                Home
              </a>
            </li>

           <li>
              <a className="smoothscroll" href="#about">
                About
              </a>
            </li>

          </ul>
        </nav>

        <div className="row banner">
          <div className="banner-text">
            <Fade bottom>
              <h1 className="responsive-headline">{this.state.name}</h1>
            </Fade>
            <Fade bottom duration={1200}>
              <h3>{this.state.description}</h3>
            </Fade>
            <hr />

           
                    {/* <label htmlFor="contactName">
                      Name <span className="required">*</span>
                    </label> */}
                    <input
                      type="text"
                      defaultValue={this.state.City_name}
                      size="35"
                      id="City_name"
                      name="City_name"
                    />
          
            <Fade bottom duration={2000}>
              <ul className="social">
                <button className="button btn project-btn" onClick={this.handleclick.bind(this)}>
                  <i className="fa fa-book"></i> Get temperature
                </button>
                {/* <a href={github} className="button btn github-btn">
                  <i className="fa fa-github"></i>Github
                </a> */}
              </ul>
            </Fade>
          </div>
        </div>

        <p className="scrolldown">
          <a className="smoothscroll" href="#about">
            <i className="icon-down-circle"></i>
          </a>
        </p>
      </header>
    );
  }
}

export default Header;
